import React from 'react'

const Item = ({Obj,setID,setName,setCode,setSave}) => {
    const EditFunction = ()=>{
        setID(Obj.id); setName(Obj.name); setCode(Obj.code); setSave('Update');
    }
  return (
    <tr className='form_item_row_container discription' onClick={EditFunction} style={{cursor:"pointer"}}>
      <td className='form_item_row_container_itemfull' style={{width:'20%'}}>
        <div style={{
          backgroundColor : Obj.code,
          height: "15px",
          width: "15px"
        }}>

        </div>
      </td>
      <td className='form_item_row_container_item' style={{width:'30%'}}>
        <p>{Obj.name}</p>
      </td>
      <td className='form_item_row_container_item' style={{width:'50%'}}>
        <p>{Obj.code}</p>
      </td>
    </tr>
  )
}

export default Item
